/* eslint-disable */

function books_filter(filter_bar, additional_data) {
  var item_holder = $(filter_bar.attr('data-listing'));
  // var filters = {};

  item_holder.addClass('animating');
  filter_bar.addClass('animating');

  var data = {
    'action': 'filter_books',
    'nonce': nonce_string
  };

  data.category = filter_bar.find('select[name="categoryfilter"]').val();

  // Merge additional data for pagination
  $.extend(data, additional_data);

  $.ajax({
    type: 'POST',
    url: ajaxurl,
    data: data,
    success: function(response) {
      item_holder.addClass('content_switch');
      item_holder.removeClass('animating');

      // console.log( response.data );

      if(response.success) {

        // console.log( data );

        setTimeout(function() {
          if(response.data.html !== 'false'){
            item_holder.find('> .inr').html(response.data.html);
            // match_heights();
          } else {
            item_holder.find('> .inr').html('<div class="no_posts col-12">No posts found.</div>');
          }

          item_holder.addClass('content_switched');

          setTimeout(function(){
            item_holder.removeClass('content_switch');
            item_holder.removeClass('content_switched');
            filter_bar.removeClass('animating');
          
            if(response.data.html !== 'false'){
              item_holder.find('.ajax_book').each(function(){

                var book = $(this);
                var index = item_holder.find('.ajax_book').index(book);

                setTimeout(function(){
                  book.addClass('loaded');
                }, index * 500);
              });

              // If pagination found, add active class to that page
              // if( additional_data.paged ){
              //   $('#pager > div:contains(' + additional_data.paged + ')').addClass('active');
              // }
              
            } else {
              // filter_bar.find('.products-found > #count').html(0);
            }
          }, 150);

        }, 150);
      }
    },
    error: function(error_response){
    //   item_holder.find('> .inner').html(ajaxErrorMessage());

    item_holder.html( error_response.responseText );

    // console.log( error_response );
    }
  });
}


export default {
  init() {
    // JavaScript to be fired on all pages

    // Match height
	$('.match_height').matchHeight();

	// Toggle mobile menu
  $('#nav_toggle').click(function(){
    $(this).toggleClass('is-active');
    $('body').toggleClass('menu_open');
    $('header').toggleClass('menu_open');
    $('#mobile_menu').stop().slideToggle();
  });

   //  // Toggle mobile menu children
   //  $('#mobile_menu .mobile_menu_nav > li .toggle').click(function(){
   //    $(this).toggleClass('open');

   //    var $target = $(this).next().stop().slideToggle();

   //    $('ul.sub-menu').not($target).slideUp();
   //    $('.toggle').not(this).removeClass('open');

   //    // $(this).next().stop().slideToggle();
   //  });

    // $('#image_gallery').owlCarousel({
    // 	items:1,
    // 	animateOut: 'fadeOut',
    // 	animateIn: 'fadeIn'
    // });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // $('select#book_categories').niceSelect();

    // Submit book filter form
    $('#book_categories').change(function() {
      // this.form.submit();

      var form_element = $(this);
      var filter_search = form_element.parents('.filter_search');

      // console.log( filter_search );

      books_filter(filter_search, {});
    });

    // Track start time AJAX
    function track_start_time() {
      // var day = new Date().getDate();
      // var month = new Date().getMonth(); // Add 1 later as getMonth returns 0-11 :-/
      // var year = new Date().getFullYear();
      // var hour = new Date().getHours();
      // var minute = new Date().getMinutes();

      // var start_time = hour + ',' + minute + ',' + 0 + ',' + (month + 1) + ',' + day + ',' + year;
      // var book_start = start_time;

      var date = new Date().toDateString();
      var time = new Date().toLocaleTimeString('en-UK');
      var date_time = date + ' ' + time;

      // console.log( date_time );

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          'action': 'track_reading_time',
          'nonce': nonce_string,
          'start_time': date_time
        },
        success: function(data) {
          if(data.success) {
            //Cookies.set('book_start', date_time, { expires: 0.006 } ); // Expires in 10 minutes
          }
        }
      });

    }


    // Track start time AJAX
    function track_end_time() {
      var date = new Date().toDateString();
      var time = new Date().toLocaleTimeString('en-UK');
      var date_time = date + ' ' + time;

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          'action': 'track_reading_time',
          'nonce': nonce_string,
          'end_time': date_time
        },
        success: function(data) {
          if(data.success) {
            // Cookies.set('book_end', date_time, { expires: 0.006 } ); // Expires in 10 minutes
          }
        }
      });

    }


    // Trigger start and end times on open and close book modal
    $('#book_modal').on('shown.bs.modal', function(e) {
      track_start_time();
    }).on('hidden.bs.modal', function (e) {
      track_end_time();
    });

    // Trigger end time on assigment completion button (instead of closing modal)
    $('form#book_complete').submit(function(event) {
      track_end_time();
    });




    /////
    // function check_filter_class() {
    //   if ( $('.book').hasClass('hide') ) {
    //     $('.book').removeClass('hide');
    //   }
    // };

    // $('.filter').click(function() {
    //   var filter_class = $(this).data('filter');

    //   $('.filter').removeClass('active');
    //   $(this).addClass('active');

    //   if( filter_class == 'all' ){
    //     check_filter_class();
    //   } else {

    //     console.log( filter_class );

    //     check_filter_class();

    //     $('.book:not(' + filter_class + ')').toggleClass('hide');

    //     $('.filter').removeClass('active');
    //     $(this).addClass('active');
    //   }
    // });





    // $('.books').isotope({
    //   itemSelector: '.book_filter',
    //   layoutMode: 'fitRows'
    // });


    // $('.books').mixItUp();


    ///////////////////


    // Close toast popup
    $('.close_toast').click(function(){
      $('.toast').toast('hide');
    });


    // Show audio popup
    $('.audio_popup .trigger .arrow').click(function() {
      var popup = $( '.audio_popup' );
      var height = popup.innerHeight();

      popup.toggleClass('open');

      if( popup.hasClass('open') ){
        $( '.audio_popup' ).animate({
          bottom: 0,
        }, 800, function(){}
        );
      } else {
        $( '.audio_popup' ).animate({
          bottom: -height,
        }, 800, function(){}
        );
      }
    });


    $('audio').audioPlayer();


    // Select correct book categories on creating student assignments
    $('.conditional_book_select').hide();
    $('#add_book_assignment select[name=book_level]').change(function() {
      var term_id = $(this).val();
      var class_to_check = '.book_select_' + term_id;

      // Hide/show correct select
      $('.conditional_book_select').not(class_to_check).hide();
      $('.conditional_book_select').not(class_to_check).find('select').prop( 'disabled', true );

      $(class_to_check).show();
      $(class_to_check).find('select').prop( 'disabled', false );
    });


    // Conditional fields on creating student assignments
    $('.conditional_students, .conditional_group').hide();
    $('#add_book_assignment select[name=class_or_individuals],#add_comp_assignment select[name=class_or_individuals]').change(function() {
      var value = $(this).val();

      if( value == 'individual' ){
        $('.conditional_students').show();
        $('.conditional_group').hide();
      } else if( value == 'class' ){
        $('.conditional_students').hide();
        $('.conditional_group').hide();
      } else if( value == 'group' ){
        $('.conditional_group').show();
        $('.conditional_students').hide();
      }
    });


    // Toggle select all checkboxes
    $('#select_all').click(function() {
      $('form#students input.remove_student_check').prop('checked', this.checked);

      $('#remove_students').prop('disabled', !$('form#students input.remove_student_check').filter(':checked').length);
    });

    var boxes = $('.remove_student_check');
    boxes.on('change', function() {
      $('#remove_students').prop('disabled', !boxes.filter(':checked').length);
    }).trigger('change');



    // Book
    var book_container = $('.book_item');
    var source = book_container.data('book');

    if( book_container.length ){
      var options = {
        soundEnable: false,
        enableDownload: false,
        icons: {
          'next': 'book_nav_next',
          'prev': 'book_nav_prev'
        },
        pageMode:DFLIP.PAGE_MODE.DOUBLE,
        // allControls: 'zoomIn, zoomOut, pageMode',
        allControls: '',
        onCreate: function(flipbook) {
          // On create get last viewed page from local storgae
          var page = localStorage.getItem(flipbook.options.id);

          if( page !==null ) {
            flipbook.options.openPage = page;
          }
        },
        onFlip: function(flipbook) {
          // Store the current viewed page in local storage
          localStorage.setItem(flipbook.options.id,flipbook.target._activePage);

          if( flipbook.target._activePage == flipbook.target.endPage ){
            // alert('end');
            $('#book_finished').fadeIn('150');
          } else {
            $('#book_finished').fadeOut('50');
          }
        }
      };

      var flipBook_pdf = book_container.flipBook(source, options);
    }



    // Audio player
    $(function(){
      var audio = $('audio')[0];

      if( audio ){
        $('.play_pause').on('click', function(){
          if(audio.paused) {
            audio.play();

            $('.play_pause').removeClass('stopped');
            $('.play_pause').addClass('playing');
          }
          else {
            audio.pause();

            $('.play_pause').removeClass('playing');
            $('.play_pause').addClass('stopped');
          }
        });

        audio.ontimeupdate = function(){
          $('.progress').css('width', audio.currentTime / audio.duration * 100 + '%')
        }
      }
    });



    // $(function(){
    

      var play_pause = $('.play_pause');
      var play_pause_icon_url = play_pause.data('lottie');

      var play_icon = bodymovin.loadAnimation({
        container: play_pause[0],
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: play_pause_icon_url
      });

      play_pause.click(function() {
        if( $(this).hasClass('playing') ) {
          play_icon.playSegments( [25,0], true );
        } else {
          play_icon.playSegments( [0,25], true );
        }
      });


      // AOS.init();
      $(function() {
        AOS.init({
          // offset: 100,
          duration:600,
          // easing:'ease-in-out',
          once:true
        });

        window.addEventListener('load', AOS.refresh);
      });


      // Quiz slider
      $(document).ready(function(){
        var quiz_slider = $('#quiz_slider');
        var btn = $('form#quiz').find('button[type="submit"]');

        quiz_slider.slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          draggable:false,
          dots: false,
          autoplay: false,
        }).on('afterChange', function(event, slick, currentSlide) {
          // console.log( quiz_slider.parent('form#quiz').find('button[type="submit"]') );

          if(slick.$slides.length-1 == currentSlide) {
            btn.removeAttr('disabled');
          }

        }).on('setPosition', function () {
          var slick_height = quiz_slider.find('.slick-track').outerHeight();
          var slide_height = quiz_slider.find('.slick-slide').outerHeight();

          quiz_slider.find('.slick-track').find('.slick-slide > div').css('height', slick_height + 'px');
        });
      });

      // $(window).on('resize', function (e) {
      //   quiz_slider.find('.slick-track').find('.slick-slide .slide-wrap').css('height', slide_height + 'px');
      // });

      // play_pause.addEventListener('click', function() {
      //   animationSkipForward.playSegments([0,60], true);
      // });

      // $('#book_complete').submit(function() {
      //   var student_id = $('input[name="student_id"]').val();
      //   var assignment_id = $('input[name="assignment_id"]').val();

      //   var data = {
      //     'action' : 'mark_assignment_complete',
      //     'nonce' : nonce_string,
      //     'student_id' : student_id,
      //     'assignment_id' : assignment_id
      //   };

      //   $.ajax({
      //     type: 'POST',
      //     url: ajax_url,
      //     data: data,
      //     success: function(response) {
      //       var result = $.parseJSON(response);

      //       if(response.success) {

      //       }
      //     }
      //   });
      // });

    // });


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js